import { render, staticRenderFns } from "./contentCatalog.vue?vue&type=template&id=e01d25d2&scoped=true&"
import script from "./contentCatalog.vue?vue&type=script&lang=js&"
export * from "./contentCatalog.vue?vue&type=script&lang=js&"
import style0 from "./contentCatalog.vue?vue&type=style&index=0&id=e01d25d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01d25d2",
  null
  
)

export default component.exports